{
  "Accessibility Menu": "Menuya Gihîştinê",
  "Reset settings": "Mîhengên vegerandinê",
  "Close": "Bigire",
  "Content Adjustments": "Guhertinên Naverokê",
  "Adjust Font Size": "Mezinahiya Fontê biguherîne",
  "Highlight Title": "Sernavê nîşan bide",
  "Highlight Links": "Girêdanên nîşan bide",
  "Readable Font": "Fonta Xwendinê",
  "Color Adjustments": "Guhertinên Rengê",
  "Dark Contrast": "Pêvajoya Tarî",
  "Light Contrast": "Pêvajoya Ronahî",
  "High Contrast": "Pêvajoya Bilind",
  "High Saturation": "Tevgeriya Bilind",
  "Low Saturation": "Tevgeriya Nizm",
  "Monochrome": "Rengê Yekane",
  "Tools": "Amûr",
  "Reading Guide": "Rehbera Xwendinê",
  "Stop Animations": "Anîmasyonan Rawestîne",
  "Big Cursor": "Kursorê Mezin",
  "Increase Font Size": "Mezinahiya Fontê Mezinkirin",
  "Decrease Font Size": "Mezinahiya Fontê Kêmkirin",
  "Letter Spacing": "Dûrahiya Tîpan",
  "Line Height": "Bilindahiya Rêzê",
  "Font Weight": "Giraniya Fontê",
  "Dyslexia Font": "Fonta Disleksiya",
  "Language": "Ziman",
  "Open Accessibility Menu": "Menuya Gihîştinê Vekirî",
  "Accessibility Profiles": "Profîlên Gihîştinê",
  "Seizure Safe Profile": "Profîla Ewle Ji Bo Hêşîna Seizure",
  "Stops animations and reduces color saturation.": "Anîmasyonan rawestîne û tevgeriya rengê kêm dike.",
  "Blind Profile": "Profîla Bêdît",
  "Activates the screen reader for auditory navigation.": "Xwendekara ekranê ji bo rêkeftina dengî çalak dike.",
  "Visually Impaired Profile": "Profîla Têkçûnê Çavkanî",
  "Enhances contrast and readability for low vision.": "Pêvajoya kontrast û xwendinê bo têkçûnê çavkanî zêde dike.",
  "ADHD Friendly Profile": "Profîla Hevîdar Bo ADHD",
  "Reduces distractions for better focus.": "Têkoşîna bikarhêneran ji bo bêtir fokus kirin kêm dike.",
  "Cognitive & Learning Profile": "Profîla Hîs & Hînkirinê",
  "Helpful tools for reading and comprehension.": "Amûrên kêmkariya bo xwendin û têgihiştinê.",
  "Motor Impaired Profile": "Profîla Kêmkirina Motor",
  "Optimizes the site for keyboard-only navigation.": "Malpera ji bo rêkeftina tenê bi keyboard ve baştir dike.",
  "Headings": "Sernav",
  "Landmarks": "Nîşaneyên Girîng",
  "Links": "Girêdan",
  "Focus element": "Tîpa Fokusê",
  "Visit link": "Serdana Girêdanê"
}